import React from "react";
import Navbar from "../components/Navbar";
import HomeCarousel from "../components/HomeCarousel";

class Home extends React.Component {
    render() {
        return (
            <div>
                <div className="dark-background">
                    {/* Intro */}
                    <div className="container">
                        <div className="row align-items-center justify-content-between" style={{ minHeight: '90vh' }}>
                            <HomeCarousel/>
                            <div className="col-12 col-md-5 col-lg-6" style={{textAlign: 'center', padding: '0px 50px 20px 50px'}}>
                                <h1 className="name font-satisfy font-gradient">Deanna Dunmyer</h1>
                                <hr className="flaired-edge-separator"/>
                                <h4 className="roles font-josefin-light font-peach">Actress, AEA</h4>
                            </div>
                        </div>
                    </div>

                    {/* Navbar */}
                    <Navbar links={[
                        { text: 'Home', reference: '/home', extraClasses: 'active-link' },
                        { text: 'Resume', reference: '/resume' },
                        { text: 'Gallery', reference: '/gallery' },
                        { text: 'Voice', reference: '/voice' },
                        { text: 'Press', reference: '/press' },
                        { text: 'Contact', reference: '/contact' }
                    ]}/>
                </div>
            </div>
        );
    }
}

export default Home;